/**
 * Responsibility: say which build this is, in the sidebar's small print.
 *
 * Deploys are two separate things - a git pull on the box for the hub, and a
 * Hosting upload for this bundle - so "am I looking at the latest?" is a
 * question the page has to be able to answer about itself. A stale tab that
 * looks identical to a fresh one has cost real debugging time.
 *
 * The values are injected by `vite.config.ts` from git at build time.
 */
import type { BuildInfo } from '@kit/layout/types';

function commitDate(iso: string): string {
  if (!iso) return '';
  const when = new Date(iso);
  if (Number.isNaN(when.getTime())) return '';
  // Local time and 24 hour, because this is read against "when did I last
  // deploy" rather than against another timestamp.
  return when.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

const when = commitDate(__COMMIT_AT__);

export const buildInfo: BuildInfo = {
  lines: [`build ${__COMMIT__}`, ...(when ? [when] : [])],
};
